// extracted by mini-css-extract-plugin
module.exports = {"Button":"C_sd y_sd y_r4 g_ff g_ft g_fj g_g4","full":"C_sZ g_df g_dq","width100":"C_df g_df","design3Pos":"C_s0 g_dK"};